var React = require('react');

function IconReviewer (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M437.9 686.9c0-23 2.6-45.4 7.6-66.9-145.1 16.7-349.4 84.7-349.4 203.2v103.5h465.5c-74.9-53.4-123.7-140.9-123.7-239.8zM495.5 511.9c47.1-63.6 119.2-107.5 201.8-117.3 13-27.1 20.2-57.4 20.2-89.4C717.6 190.7 625 98 510.5 98s-207.1 92.8-207.1 207.2c-.1 109.5 84.6 199 192.1 206.7z","key":0}),React.createElement("path",{"d":"M706.8 460.3c-121.9 0-220.7 98.8-220.7 220.7s98.8 220.7 220.7 220.7c121.9 0 220.7-98.8 220.7-220.7s-98.8-220.7-220.7-220.7zm138.4 141.8L681.7 789.5c-.9 1-2.4 1.1-3.5.3l-114.6-92.7c-1.1-.9-1.2-2.5-.2-3.6l29.2-32.1c.9-1 2.3-1.1 3.4-.2l79.6 64.5 131.1-155.4c.9-1 2.4-1.2 3.5-.3l34.8 28.6c.9.9 1.1 2.5.2 3.5z","key":1})]);
}

IconReviewer.displayName = "IconReviewer";

IconReviewer.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconReviewer;

IconReviewer.default = IconReviewer;
